<mat-card>
  <mat-card-content>
    <app-tasks
      [showLastModified]="true"
      [showCreateDate]="true"
      [showProjectRole]="true"
      [showProject]="true"
      [showPlan]="true"
      [showDueDate]="true"
      [showTags]="true"
      [showStatus]="true"
      [showPriority]="true"
      [showType]="true"
      [showCreate]="true"
      [showAssignedAccount]="true"
      [showComponents]="true"
      [enableSavedFilters]="true"
      (drawerOpened)="drawerOpened($event)"
      [persistName]="'fs-filter-persist-project-tasks'">
    </app-tasks>
  </mat-card-content>
</mat-card>